import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface AuthState {
  jwtToken: string | null;
  data: {} | null;
  token: string | null;
  userType: string | null;
  id: number | string | null;
  customerId: number | string | null;
  nav:null |boolean;
}

const initialState: AuthState = {
  jwtToken: null,
  data: null,
  id: null,
  token: null,
  userType: null,
  customerId: null,
  nav:false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<{
        userType: string | null;
        token: string | null;
        jwtToken: string | null;
        id: string | number | null;
        data: {} | null;
        customerId: number | null;
      }>
    ) => {
      state.jwtToken = action.payload?.jwtToken;
      state.data = action.payload;
      state.token = action.payload?.token;
      state.userType = action.payload?.userType;
      state.customerId = action.payload?.customerId;
    },
    setAuth: (
      state,
      action: PayloadAction<{
        jwtToken: string | null;
        id: string | number | null;
        data: {} | null;
        customerId: string | number | null;
      }>,
    ) => {
      state.jwtToken = action.payload.jwtToken;
      state.id = action.payload.id;
      state.customerId = action.payload.customerId;
      state.data = action.payload;
    },
    reset: (state) => {
      state.jwtToken = null;
      state = initialState;
    },
    setIsNavigation: (state: any, action) => {
      state.nav = true;
    },
    resetIsNavigation:(state: any, action) => {
      state.nav = false;
    },
  },
});

export const { setAuth , setUser,reset,setIsNavigation,resetIsNavigation } = authSlice.actions;
export const getUserData = (state: any) => state.auth.data;
export const getUserType = (state: any) => state.auth?.userType;
export const getUserId = (state: any) => state.auth.data?.id;
export const selectJwtToken = (state: any) => state.auth?.jwtToken;
export const selectData = (state: RootState) => state.auth.data;
export const getCustomerId = (state: RootState) => state.auth.customerId;
export const isNavigation=(state:RootState)=>state.auth.nav;

export default authSlice.reducer;
